import { whatsappUtilsApi } from './createApi';

const whatsappUtils = {
	createDepartment: async ( payload ) => {
		const response = await whatsappUtilsApi.post( '/departments', payload );
		return response.data;
	},
	listDepartments: async () => {
		const response = await whatsappUtilsApi.get( '/departments' );
		return response.data;
	},
	updateDepartment: async ( payload ) => {
		const response = await whatsappUtilsApi.put( `/departments/${payload.id}`, payload );
		return response.data;
	},
	createUser: async ( payload ) => {
		const response = await whatsappUtilsApi.post( '/users', payload );
		return response.data;
	},
	listUsers: async () => {
		const response = await whatsappUtilsApi.get( '/users' );
		return response.data;
	},
	updateUser: async ( payload ) => {
		const response = await whatsappUtilsApi.put( `/users/${payload.id}`, payload );
		return response.data;
	},
	deactivateUser: async ( id ) => {
		const response = await whatsappUtilsApi.put( `/users-af/${id}/status` );
		return response.data;
	},
	listProfileTypes: async () => {
		const response = await whatsappUtilsApi.get( '/profile-types' );
		return response.data;
	}
};

export default whatsappUtils;